import { render } from "./ModalItemList.vue?vue&type=template&id=226ab7da&scoped=true"
import script from "./ModalItemList.vue?vue&type=script&lang=js"
export * from "./ModalItemList.vue?vue&type=script&lang=js"

import "./ModalItemList.vue?vue&type=style&index=0&id=226ab7da&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226ab7da"]])

export default __exports__